import axios from "axios";
import { toast } from "react-toastify";
import { RESET_PASSWORD, SIGNUP_ENDPOINT } from "../../appConstants";

export const registerUser = async (params) => {
  const { name, username, password } = params;

  const data = {
    name,
    username,
    password,
  };

  const config = {
    method: "post",
    url: SIGNUP_ENDPOINT,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (response.data.success === true) {
      toast.success(`Success: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else if (response.data.error === "PasswordExpired") {
      window.location.replace("/update-password");
    } else {
      toast.error(`Error: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${"Something Went Wrong"}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};

export const updatePassword = async (params) => {
  const { username, old_password, new_password } = params;

  const data = {
    username,
    old_password,
    new_password,
  };

  const config = {
    method: "post",
    url: RESET_PASSWORD,
    headers: {
      Authorization: `Bearer ${localStorage.access_token}`,
    },
    data: data,
  };

  try {
    const response = await axios(config);
    if (response.data.success === true) {
      toast.success(`Success: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    } else if (response.data.error === "PasswordExpired") {
      toast.error(`Error: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      window.location.replace("/update-password");
    } else {
      toast.error(`Error: ${response.data.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
    return response.data;
  } catch (error) {
    toast.error(`Error: ${"Something Went Wrong"}`, {
      position: toast.POSITION.BOTTOM_CENTER,
    });
  }
};
